import { render, staticRenderFns } from "./ControllerSet.vue?vue&type=template&id=045595fd&scoped=true"
import script from "./ControllerSet.vue?vue&type=script&lang=js"
export * from "./ControllerSet.vue?vue&type=script&lang=js"
import style0 from "./ControllerSet.vue?vue&type=style&index=0&id=045595fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045595fd",
  null
  
)

export default component.exports